
export const StatCard = ({ label, value, hint }: { label: string; value: string; hint?: string }) => (
  <div className="rounded-xl border border-neutral-200 p-4 sm:p-5 bg-white shadow-sm">
    <div className="text-xs uppercase tracking-wider text-neutral-500 font-medium">{label}</div>
    <div className="mt-1 text-2xl font-semibold text-neutral-900">{value}</div>
    {hint ? <div className="mt-1 text-[12px] text-neutral-500">{hint}</div> : null}
  </div>
);


